export default {
	name: 'External Failure',
	description: 'After Delivery, Issue Reaches Customers, Creates Field Failures, Returns, Warranties and Lost Customers. Cost to Recover from Errors and Defective Product',
	completed: false,
	color: '#FF4560',
	banner: 'parallax-blue.jpg',
	costs: [
		{
			name: 'Lost Customers',
			color: '',
			deleted: false,
			verified: false,
			visible: true,
			subCosts: [
				{
					name: 'Design Engineering',
					value: null
				},
				{
					name: 'Purchasing',
					value: null
				},
				{
					name: 'Production',
					value: null
				},
				{
					name: 'Accounting',
					value: null
				},
				{
					name: 'Finance',
					value: null
				},
				{
					name: 'Quality',
					value: null
				},
				{
					name: 'Materials',
					value: null
				},
				{
					name: 'Sales & Marketing',
					value: null
				},
				{
					name: 'Other',
					value: null
				}
			],
		},
		{
			name: 'Returns',
			color: '',
			deleted: false,
			verified: false,
			visible: true,
			subCosts: [
				{
					name: 'Design Engineering',
					value: null
				},
				{
					name: 'Purchasing',
					value: null
				},
				{
					name: 'Production',
					value: null
				},
				{
					name: 'Accounting',
					value: null
				},
				{
					name: 'Finance',
					value: null
				},
				{
					name: 'Quality',
					value: null
				},
				{
					name: 'Materials',
					value: null
				},
				{
					name: 'Sales & Marketing',
					value: null
				},
				{
					name: 'Other',
					value: null
				}
			],
		},
		{
			name: 'Recalls',
			color: '',
			deleted: false,
			verified: false,
			visible: true,
			subCosts: [
				{
					name: 'Design Engineering',
					value: null
				},
				{
					name: 'Purchasing',
					value: null
				},
				{
					name: 'Production',
					value: null
				},
				{
					name: 'Accounting',
					value: null
				},
				{
					name: 'Finance',
					value: null
				},
				{
					name: 'Quality',
					value: null
				},
				{
					name: 'Materials',
					value: null
				},
				{
					name: 'Sales & Marketing',
					value: null
				},
				{
					name: 'Other',
					value: null
				}
			],
		},
		{
			name: 'Field Services',
			color: '',
			deleted: false,
			verified: false,
			visible: true,
			subCosts: [
				{
					name: 'Design Engineering',
					value: null
				},
				{
					name: 'Purchasing',
					value: null
				},
				{
					name: 'Production',
					value: null
				},
				{
					name: 'Accounting',
					value: null
				},
				{
					name: 'Finance',
					value: null
				},
				{
					name: 'Quality',
					value: null
				},
				{
					name: 'Materials',
					value: null
				},
				{
					name: 'Sales & Marketing',
					value: null
				},
				{
					name: 'Other',
					value: null
				}
			],
		},
		{
			name: 'After Delivery',
			color: '',
			deleted: false,
			verified: false,
			visible: true,
			subCosts: [
				{
					name: 'Design Engineering',
					value: null
				},
				{
					name: 'Purchasing',
					value: null
				},
				{
					name: 'Production',
					value: null
				},
				{
					name: 'Accounting',
					value: null
				},
				{
					name: 'Finance',
					value: null
				},
				{
					name: 'Quality',
					value: null
				},
				{
					name: 'Materials',
					value: null
				},
				{
					name: 'Sales & Marketing',
					value: null
				},
				{
					name: 'Other',
					value: null
				}
			],
		},
	]
};